import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Standalone pipeline detail route (`/pipelines/$pipelineId`). Lives OUTSIDE the
 * Integrations layout on purpose — it's a full-page detail view, so it doesn't
 * carry the Connections/Pipelines/Health/Data Lake tab rail. Super-admin only.
 */
const PipelineDetailPage = lazy(() => import('~/features/integrations/pages/pipeline-detail-page'));

// Declares the shared subsidiary scope (`sc`) — the Pipelines list is
// cross-subsidiary, so a row from a picked subsidiary must keep its scope here
// and forward it on to the run detail page.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/pipelines/$pipelineId')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

/** Reads the route param and renders the lazy page inside the page-gradient shell. */
function RouteComponent() {
  const { pipelineId } = Route.useParams();
  return (
    <div className="bg-gradient-page min-h-full p-6">
      <Suspense fallback={<PageSkeleton />}>
        <PipelineDetailPage pipelineId={pipelineId} />
      </Suspense>
    </div>
  );
}
